import axios from 'axios';
import { IOptionsReturn, ISavePrivateSurveyParams } from './types/privateSurvey';
import { IAddMatchParams, IAddMatchReturn, ISavePrivateSurveyJobsParams, ISaveSurveyJobReturn, ISurveySourceReturn, IUDFFieldReturn } from './types/privateSurveyJob';

export async function addMatch(masterAccountId: string | number, params: IAddMatchParams): Promise<IAddMatchReturn> {
  return (
    await axios.post<IAddMatchReturn>(`/cms/api/accounts/${masterAccountId}/survey-jobs/match`, params)
  ).data;
}

export async function getGeographies(masterAccountId: string | number): Promise<IOptionsReturn> {
  return (
    await axios.get<IOptionsReturn>(`/cms/api/accounts/${masterAccountId}/private-survey-jobs/geographies`)
  ).data;
}

export async function getIndustries(masterAccountId: string | number): Promise<IOptionsReturn> {
  return (
    await axios.get<IOptionsReturn>(`/cms/api/accounts/${masterAccountId}/private-survey-jobs/industries`)
  ).data
}

export async function getSurveySourceOptions(masterAccountId: string | number): Promise<ISurveySourceReturn> {
  return (
    await axios.get<ISurveySourceReturn>(`/cms/api/accounts/${masterAccountId}/private-survey-jobs/options`)
  ).data;
}

export async function getUDFFields(masterAccountId: string | number): Promise<IUDFFieldReturn> {
  return (
    await axios.get<IUDFFieldReturn>(`/cms/api/accounts/${masterAccountId}/private-survey-jobs/udfs`)
  ).data;
}

export async function savePrivateSurvey(masterAccountId: string | number, params: ISavePrivateSurveyParams): Promise<ISaveSurveyJobReturn> {
  return (
    await axios.post<ISaveSurveyJobReturn>(`/cms/api/accounts/${masterAccountId}/private-survey-jobs/survey`, params)
  ).data;
}

export async function savePrivateSurveyJob(masterAccountId: string | number, params: ISavePrivateSurveyJobsParams): Promise<ISaveSurveyJobReturn> {
  return (
    await axios.post<ISaveSurveyJobReturn>(`/cms/api/accounts/${masterAccountId}/private-survey-jobs`, params)
  ).data;
}


